import { Link, useLocation, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const TABS = [
  { to: "/admin", label: "Leads", testid: "nav-leads" },
  { to: "/admin/work-orders", label: "Work Orders", testid: "nav-work-orders" },
  { to: "/admin/employees", label: "Employees", testid: "nav-employees" },
  { to: "/admin/pricing", label: "Pricing", testid: "nav-pricing" },
];

export default function AdminNav() {
  const loc = useLocation();
  const navigate = useNavigate();
  const user = (() => {
    try { return JSON.parse(localStorage.getItem("aero_user") || "{}"); } catch { return {}; }
  })();

  const logout = () => {
    localStorage.removeItem("aero_token");
    localStorage.removeItem("aero_user");
    navigate("/login");
  };

  return (
    <header className="bg-card border-b border-border sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Link to="/" className="font-display text-lg font-bold text-primary">AeroAcres</Link>
          <Badge className="bg-muted text-primary hover:bg-muted border-0">Admin</Badge>
        </div>
        <nav className="hidden md:flex items-center gap-1 overflow-x-auto">
          {TABS.map((t) => {
            const active = loc.pathname === t.to || (t.to !== "/admin" && loc.pathname.startsWith(t.to));
            return (
              <Link
                key={t.to}
                to={t.to}
                data-testid={t.testid}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors whitespace-nowrap ${
                  active ? "bg-primary text-primary-foreground" : "text-primary hover:bg-muted"
                }`}
              >{t.label}</Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-3">
          <span className="hidden lg:block text-sm text-muted-foreground">{user?.email}</span>
          <Button onClick={logout} variant="outline" size="sm" data-testid="logout-btn" className="rounded-full">
            <LogOut className="h-4 w-4 mr-1.5" /> Sign out
          </Button>
        </div>
      </div>
      {/* Mobile nav */}
      <div className="md:hidden border-t border-border overflow-x-auto">
        <nav className="flex gap-1 px-3 py-2 min-w-max">
          {TABS.map((t) => {
            const active = loc.pathname === t.to || (t.to !== "/admin" && loc.pathname.startsWith(t.to));
            return (
              <Link
                key={t.to}
                to={t.to}
                className={`px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap ${
                  active ? "bg-primary text-primary-foreground" : "text-primary hover:bg-muted"
                }`}
              >{t.label}</Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
